import { NewNotificationInDto, NewNotificationOutDto } from '../../../types/notification.dto'

export const NEW_NOTIFICATION = 'NEW_NOTIFICATION'
export const NEW_NOTIFICATION_SUCCESS = 'NEW_NOTIFICATION_SUCCESS'
export const NEW_NOTIFICATION_ERROR = 'NEW_NOTIFICATION_ERROR'
export const RESET_NEW_NOTIFICATION = 'RESET_NEW_NOTIFICATION'

export interface NewNotification {
  type: typeof NEW_NOTIFICATION
  payload: NewNotificationOutDto
}

export interface NewNotificationSuccess {
  type: typeof NEW_NOTIFICATION_SUCCESS
  payload: NewNotificationInDto
}

export interface NewNotificationError {
  type: typeof NEW_NOTIFICATION_ERROR
  payload: string | boolean
}

export interface ResetNewNotification {
  type: typeof RESET_NEW_NOTIFICATION
  payload: null
}

export interface State {
  data: NewNotificationInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = NewNotification | NewNotificationSuccess | NewNotificationError | ResetNewNotification
